import React, { useEffect, useState, useRef } from 'react';
import { X } from 'lucide-react';
const countdownSequence = [{
  delay: 5000,
  drop: 1
}, {
  delay: 8000,
  drop: 1
}, {
  delay: 5000,
  drop: 2
}, {
  delay: 12000,
  drop: 1
}, {
  delay: 6000,
  drop: 3
}, {
  delay: 17000,
  drop: 1
}, {
  delay: 9000,
  drop: 2
}, {
  delay: 5000,
  drop: 1
}, {
  delay: 14000,
  drop: 3
}, {
  delay: 7000,
  drop: 1
}, {
  delay: 11000,
  drop: 2
}, {
  delay: 8000,
  drop: 1
}, {
  delay: 20000,
  drop: 1
}, {
  delay: 6000,
  drop: 3
}, {
  delay: 15000,
  drop: 1
}, {
  delay: 5000,
  drop: 2
}, {
  delay: 10000,
  drop: 1
}, {
  delay: 9000,
  drop: 2
}, {
  delay: 13000,
  drop: 1
}, {
  delay: 7000,
  drop: 3
}];
export function StickyTopBar() {
  const [isVisible, setIsVisible] = useState(true);
  const [remaining, setRemaining] = useState(47);
  const [flash, setFlash] = useState(false);
  const stepRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function scheduleNext() {
      const step = stepRef.current % countdownSequence.length;
      const {
        delay,
        drop
      } = countdownSequence[step];
      timerRef.current = setTimeout(() => {
        setRemaining(prev => {
          const next = prev - drop;
          return next < 3 ? 3 : next;
        });
        setFlash(true);
        setTimeout(() => setFlash(false), 600);
        stepRef.current++;
        scheduleNext();
      }, delay);
    }
    scheduleNext();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="sticky top-0 left-0 w-full z-[9999] bg-[#FF0000] text-white font-sans flex items-center justify-center px-8 py-2 min-h-[50px] md:h-[50px] shadow-md" data-id="element-270">
      <div className="text-center text-xs md:text-sm font-bold leading-tight max-w-3xl" data-id="element-271">
        <span className="block md:inline" data-id="element-272">
          🔥 Launch Special: Only 200 copies at this price —{' '}
        </span>
        <span className={`inline-block md:ml-1 underline decoration-2 transition-all duration-300 ${flash ? 'scale-125 text-yellow-300' : 'scale-100 text-white'}`} data-id="element-273">
          {remaining} remaining.
        </span>
        <span className="block md:inline md:ml-1" data-id="element-274">
          {' '}
          Price jumps to $305 when they're gone.
        </span>
      </div>

      <button onClick={() => setIsVisible(false)} className="absolute right-2 md:right-4 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Close banner" data-id="element-275">
        <X className="w-4 h-4 md:w-5 md:h-5" data-id="element-276" />
      </button>
    </div>;
}